import React from "react";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/ui/button";
import { ChipFilterGroup } from "@/components/ChipFilterGroup/ChipFilterGroup";
import { cn } from "@/utils/utils";
import { StatusFilter } from "../../utils/mpDashboardFilterParams";
import { MPDashboardChipFilters } from "../../hooks/useMPDashboardChipFilters";

interface MPDashboardFiltersProps {
  chipFilters: MPDashboardChipFilters;
  statusFilter: StatusFilter;
  onFilterChange: (filter: StatusFilter) => void;
  statusCounts: Record<StatusFilter, number>;
  onExportCsv: () => void;
  csvLoading: boolean;
}

const FILTER_OPTIONS: { value: StatusFilter; label: string }[] = [
  { value: "all", label: "All" },
  { value: "recommend", label: "Recommend" },
  { value: "review", label: "Review" },
  { value: "low", label: "Low" },
];

const MPDashboardFilters: React.FC<MPDashboardFiltersProps> = ({
  chipFilters,
  statusFilter,
  onFilterChange,
  statusCounts,
  onExportCsv,
  csvLoading,
}) => {
  return (
    <div className="space-y-2">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center">
          <div className="grid grid-cols-2 gap-2 sm:flex sm:items-center">
            {FILTER_OPTIONS.map((option) => {
              const isActive = statusFilter === option.value;
              return (
                <button
                  className={cn(
                    "inline-flex items-center justify-center gap-2 h-9 px-3 py-1 rounded-md border shadow-sm text-sm font-medium transition-colors",
                    isActive
                      ? "bg-primary border-primary text-white hover:bg-primary/90"
                      : "bg-white border-gray-200 text-gray-600 hover:border-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:border-white/20 dark:text-white dark:hover:border-white/30 dark:hover:bg-gray-700",
                  )}
                  key={option.value}
                  onClick={() => onFilterChange(option.value)}
                  type="button"
                >
                  {option.label} ({statusCounts[option.value]})
                </button>
              );
            })}
          </div>
          <div className="hidden sm:block h-6 w-px bg-gray-200 dark:bg-slate-700" />
          <ChipFilterGroup
            filters={chipFilters.filterConfigs}
            onChange={chipFilters.handleFilterChange}
            showActiveFilters={false}
            values={chipFilters.filterValues}
          />
        </div>
        <Button
          className="flex items-center gap-2"
          disabled={csvLoading}
          onClick={onExportCsv}
        >
          <ArrowDownTrayIcon className="h-4 w-4" />
          {csvLoading ? "Exporting..." : "Export CSV"}
        </Button>
      </div>
      <ChipFilterGroup
        filters={chipFilters.filterConfigs}
        onChange={chipFilters.handleFilterChange}
        onClearAll={chipFilters.handleFilterClearAll}
        showChips={false}
        values={chipFilters.filterValues}
      />
    </div>
  );
};

export default MPDashboardFilters;
